/**
 */

define('directives/common/mul-select/mulSelect.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('mulSelect', ['UserInfo','auiDialog','$timeout',function (UserInfo,auiDialog,$timeout) {
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: 'directives/common/mul-select/mulSelect.template.html',
            scope: {
            	selectStyle: "=",
            	placeHolder: "=",
            	selectChange: "=",
            	selectResult: "=",
            	selectItem:"=",
            	disabledSet:"=",
            	changeCallback:"="
            },
            link: function ($scope, element, attrs) {
            	var selectLabelArray = [];
            	$scope.selectLabels = '';
            	$scope.selectValueArray = [];
                function init(time){
                	 new UCD.SelectCountry('.select-country');
                	 $timeout(function () {
                		 initSelectLabels();
                     },time);
                }
                init(3000);

                function initSelectLabels(){
                	selectLabelArray = [];
                	$scope.selectLabels = '';
                	$scope.selectValueArray = [];
                	for(var i = 0;i<$scope.selectResult.length;i++){
                		$scope.selectValueArray.push($scope.selectResult[i]['key']);
                		selectLabelArray.push($scope.selectResult[i]['key']);
                	}
                	var selectItemValue = [];
                	for(var k=0;k<$scope.selectItem.length;k++){
                		$scope.selectItem[k]['isShow'] = true;
                		selectItemValue.push($scope.selectItem[k]['value']);
                	}
                	for(var j=0;j<$scope.selectValueArray.length;j++){
                		if(selectItemValue.indexOf($scope.selectValueArray[j]) == -1){
                			$scope.selectItem.push({key:$scope.selectValueArray[j],value:$scope.selectValueArray[j],isShow:false});
                		}
                	}
                	$scope.selectLabels = selectLabelArray.join(',');
                }

                $scope.changeSelected = function(item){
                	var selectItem = [];
                	for(var i=0;i<$scope.selectItem.length;i++){
                		if($scope.selectItem[i]['isShow']){
                			selectItem.push($scope.selectItem[i]);
                		}else{
                			$scope.selectValueArray.splice($scope.selectValueArray.indexOf($scope.selectItem[i]['key']), 1);
                			selectLabelArray.splice(selectLabelArray.indexOf($scope.selectItem[i]['value']), 1);
                			for(var j=0;j<$scope.selectResult.length;j++){
                				if($scope.selectItem[i]['key'] == $scope.selectResult[j]['key']){
                					$scope.selectResult.splice(j, 1);
                				}
                			}
                		}
                	}
                	$scope.selectItem = selectItem;
                	$scope.selectLabels = selectLabelArray.join(',');
                	if(item){
                		if($scope.selectValueArray.indexOf(item.value) != -1){
                			$scope.selectValueArray.splice($scope.selectValueArray.indexOf(item.key), 1);
                			selectLabelArray.splice(selectLabelArray.indexOf(item.value), 1);
                			for(var k=0;k<$scope.selectResult.length;k++){
                				if(item.key == $scope.selectResult[k]['key']){
                					$scope.selectResult.splice(k, 1);
                				}
                			}
                		}else{
                			$scope.selectValueArray.push(item.key);
                			selectLabelArray.push(item.value);
                			$scope.selectResult.push({key:item.key,value:item.value});
                		}
                	}else{
                		if($scope.selectResult.length != $scope.selectItem.length){
                			$scope.selectResult = [];
                			selectLabelArray = [];
                			$scope.selectValueArray = [];
                			for(var jj=0;jj<$scope.selectItem.length;jj++){
                				$scope.selectResult.push({key:$scope.selectItem[jj]['key'],value:$scope.selectItem[jj]['value']});
                    			selectLabelArray.push($scope.selectItem[jj]['value']);
                    			$scope.selectValueArray.push($scope.selectItem[jj]['key']);
                        	}
                		}else{
                			$scope.selectResult = [];
                			selectLabelArray = [];
                			$scope.selectValueArray = [];
                		}
                	}
                	$scope.selectLabels = selectLabelArray.join(',');
                	if($scope.changeCallback){
                		$scope.changeCallback();
                	}
                }

                $scope.$watch('selectResult', function (newValue, oldValue) {
                	 if (newValue != oldValue) {
                		 init(1000);
                	 }
                });

                $scope.$watch('selectItem', function (newValue, oldValue) {
                  	 if (newValue != oldValue) {
                  		init(1000);
                  	 }
                });
            }
        }
    }]);
});

